import React, { useState, useEffect } from "react";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";

// Default export React component
// Props:
// - worker: { name, role, department, employee_id, age, gender, photo_url, company_logo_url }
// - onFlip (optional): callback when card flips
// - size (optional): card width in px (default 320)

export default function IdCard({ onFlip, size = 320 }) {
  const [flipped, setFlipped] = useState(false);
  const [workers, setWorkers] = useState([]);

  const handleFlip = () => {
    const next = !flipped;
    setFlipped(next);
    if (onFlip) onFlip(next);
  };
  useEffect(() => {
    // const email = localStorage.getItem("email");
    axios
      .get("http://localhost:5000/api/company-id")
      .then((response) => {
        console.log(response.data);
        setWorkers(response.data);
      })
      .catch((err) => {
        console.error(
          "Workers fetch failed:",
          err.response?.data || err.message
        );
        throw new Error(
          `Workers fetch failed: ${err.response?.data.message || err.message}`
        );
      });
    // const email = localStorage.getItem("email");
    // axios.get("http://localhost:5000/api/company-id", email)
    //   .then(response => {
    //     console.log(response.data)
    //     setWorkers(response.data)
    //   })
  }, []);
  //   const {
  //     name = "—",
  //     role = "—",
  //     department = "—",
  //     employee_id = "—",
  //     age = null,
  //     gender = "—",
  //     photo_url = null,
  //     company_logo_url = null
  //   } = worker || {};

  // QR value points to your verification endpoint. Replace host as needed.
  const qrValue = `${window.location.origin}/api/workers/${workers.user_id}`;

  return (
    <div className="flex flex-col items-center">
      <div className="perspective" style={{ width: size }}>
        <div
          className={`relative w-full h-[420px] transform-style-preserve-3d transition-transform duration-700 ${
            flipped ? "rotate-y-180" : "rotate-y-0"
          }`}
          style={{ transformStyle: "preserve-3d" }}
        >
          {/* Front */}
          <div
            className="absolute inset-0 backface-hidden rounded-2xl border shadow-lg bg-white overflow-hidden flex flex-col"
            style={{
              WebkitBackfaceVisibility: "hidden",
              backfaceVisibility: "hidden",
            }}
          >
            <div className="bg-gradient-to-r from-purple-700 to-purple-500 p-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                {/* {company_logo_url ? (
                  <img src={company_logo_url} alt="logo" className="h-10 w-10 object-contain rounded" />
                ) : (
                  <div className="h-10 w-10 rounded bg-white/20 flex items-center justify-center text-white font-semibold">LOGO</div>
                )} */}
                <div className="text-white">
                  <div className="text-sm">Employee ID Card</div>
                  <div className="text-xs opacity-80">{workers.department}</div>
                </div>
              </div>
              <div className="text-white text-xs">
                ID: {workers.employee_id}
              </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-center p-6 gap-3">
              {workers.image ? (
                <img
                  src={workers.image}
                  alt="photo"
                  className="h-28 w-28 rounded-full object-cover border-2 border-white shadow"
                />
              ) : (
                <div className="h-28 w-28 rounded-full bg-gray-200 flex items-center justify-center text-gray-600">
                  No Photo
                </div>
              )}

              <div className="text-center">
                <h2 className="text-xl font-semibold">{workers.name}</h2>
                <p className="text-sm text-gray-600">{workers.role}</p>
                <p className="text-sm text-gray-500 mt-1">
                  {workers.gender} {workers.age ? `• ${workers.age}` : ""}
                </p>
              </div>

              <div className="mt-4 text-xs text-gray-500">
                Property of Mosaic
              </div>
            </div>

            <div className="p-4 flex items-center justify-between">
              <button
                onClick={handleFlip}
                className="px-4 py-2 rounded-lg bg-purple-600 text-white hover:bg-purple-700 transition"
              >
                Flip Card
              </button>

              <button
                onClick={() => window.print()}
                className="px-3 py-2 rounded border text-sm"
              >
                Print
              </button>
            </div>
          </div>

          {/* Back */}
          <div
            className="absolute inset-0 backface-hidden rounded-2xl border shadow-lg bg-white p-6 flex flex-col items-center justify-between"
            style={{
              transform: "rotateY(180deg)",
              WebkitBackfaceVisibility: "hidden",
              backfaceVisibility: "hidden",
            }}
          >
            <div className="w-full flex items-center justify-between">
              <div className="text-sm font-semibold">Verification</div>
              <div className="text-xs text-gray-500">{workers.department}</div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-center gap-4">
              <div className="bg-white p-2 rounded">
                <QRCodeCanvas value={qrValue} size={140} level="H" />
              </div>

              <div className="text-center text-sm">
                <div className="font-medium">Scan to verify</div>
                <div className="text-xs text-gray-500 mt-1 max-w-[240px] break-words">
                  Scans will point to:{" "}
                  <span className="font-mono">/api/workers/{workers._id}</span>
                </div>
              </div>
            </div>

            <div className="w-full flex items-center justify-between">
              <button
                onClick={handleFlip}
                className="px-4 py-2 rounded-lg bg-purple-600 text-white hover:bg-purple-700 transition"
              >
                Back
              </button>

              <div className="text-xs text-gray-400">ID: {workers._id}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Small helper: click card to flip */}
      <div className="mt-3 text-sm text-gray-600">
        Click the button or card to flip
      </div>

      <style jsx>{`
        .perspective {
          perspective: 1000px;
        }
        .rotate-y-0 {
          transform: rotateY(0deg);
        }
        .rotate-y-180 {
          transform: rotateY(180deg);
        }
        .backface-hidden {
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
        }
      `}</style>

      {/* Make the whole card clickable to flip */}
      <div
        aria-hidden
        onClick={() => handleFlip()}
        className="absolute inset-0"
        style={{
          width: size,
          height: 420,
          top: 0,
          left: `calc(50% - ${size / 2}px)`,
        }}
      />
    </div>
  );
}
